export const loginButtonMetaData = {
    isRepeatable: false
}
